// This file is automatically generated. Do not edit manually.

import { SystemDiagramDirection } from "src/api/generated/postgres/db/types/public_/enums/systemDiagramDirection";
import { SystemDiagramLink } from "src/api/generated/postgres/db/types/public_/tables/systemDiagramLink";
import { SystemDiagramNodeShape } from "src/api/generated/postgres/db/types/public_/enums/systemDiagramNodeShape";
import { SystemDiagramNodeState } from "src/api/generated/systemDiagrams/systemDiagramNodeState";
import { SystemDiagramDrilldownSectionType } from "src/api/generated/systemDiagrams/functions/systemDiagramDrilldownSectionType";
import { CustomerOrderLineView } from "src/api/generated/erp/db/types/tables/customerOrderLineView";
import { CustomerOrderView } from "src/api/generated/erp/db/types/tables/customerOrderView";
import { ShopOrderView } from "src/api/generated/erp/db/types/tables/shopOrderView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SystemDiagramViewerApi {
	export async function listManufacturing(): Promise<SystemDiagramViewerApi_DiagramListData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/listManufacturing",
			method: "POST",
			data: {},
		});
		return response as SystemDiagramViewerApi_DiagramListData;
	}

	export async function getManufacturingDiagram(args: {
		systemDiagramId: number;
	}): Promise<SystemDiagramViewerApi_DiagramData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/getManufacturingDiagram",
			method: "POST",
			data: {
				systemDiagramId: args.systemDiagramId,
			},
		});
		return response as SystemDiagramViewerApi_DiagramData;
	}

	export async function getManufacturingNodeDrilldown(args: {
		systemDiagramNodeId: number;
	}): Promise<SystemDiagramViewerApi_NodeDrilldownData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/getManufacturingNodeDrilldown",
			method: "POST",
			data: {
				systemDiagramNodeId: args.systemDiagramNodeId,
			},
		});
		return response as SystemDiagramViewerApi_NodeDrilldownData;
	}

	export async function listSales(): Promise<SystemDiagramViewerApi_DiagramListData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/listSales",
			method: "POST",
			data: {},
		});
		return response as SystemDiagramViewerApi_DiagramListData;
	}

	export async function getSalesDiagram(args: {
		systemDiagramId: number;
	}): Promise<SystemDiagramViewerApi_DiagramData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/getSalesDiagram",
			method: "POST",
			data: {
				systemDiagramId: args.systemDiagramId,
			},
		});
		return response as SystemDiagramViewerApi_DiagramData;
	}

	export async function getSalesNodeDrilldown(args: {
		systemDiagramNodeId: number;
	}): Promise<SystemDiagramViewerApi_NodeDrilldownData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/getSalesNodeDrilldown",
			method: "POST",
			data: {
				systemDiagramNodeId: args.systemDiagramNodeId,
			},
		});
		return response as SystemDiagramViewerApi_NodeDrilldownData;
	}

	export async function listSpc(): Promise<SystemDiagramViewerApi_DiagramListData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/listSpc",
			method: "POST",
			data: {},
		});
		return response as SystemDiagramViewerApi_DiagramListData;
	}

	export async function getSpcDiagram(args: {
		systemDiagramId: number;
	}): Promise<SystemDiagramViewerApi_DiagramData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/systemDiagrams/viewer/getSpcDiagram",
			method: "POST",
			data: {
				systemDiagramId: args.systemDiagramId,
			},
		});
		return response as SystemDiagramViewerApi_DiagramData;
	}
}

export interface SystemDiagramViewerApi_DiagramListData {
	diagrams: Array<SystemDiagramViewerApi_SystemDiagramListItem>;
}

export interface SystemDiagramViewerApi_SystemDiagramListItem {
	name: string;
	systemDiagramId: number;
}

export interface SystemDiagramViewerApi_DiagramData {
	direction: SystemDiagramDirection;
	links: Array<SystemDiagramLink>;
	name: string;
	nodes: Array<SystemDiagramViewerApi_SystemDiagramNodeData>;
	systemDiagramId: number;
}

export interface SystemDiagramViewerApi_SystemDiagramNodeData {
	controlChartId: number | null | undefined;
	hasDrilldown: boolean;
	name: string;
	shape: SystemDiagramNodeShape;
	state: SystemDiagramNodeState;
	systemDiagramNodeId: number;
}

export interface SystemDiagramViewerApi_NodeDrilldownData {
	sections: Array<SystemDiagramViewerApi_NodeDrilldownSection>;
	title: string;
}

export interface SystemDiagramViewerApi_NodeDrilldownSection {
	rows: SystemDiagramViewerApi_NodeDrilldownRows;
	type: SystemDiagramDrilldownSectionType;
}

export interface SystemDiagramViewerApi_NodeDrilldownRows {
	customerOrderLines: Array<CustomerOrderLineView>;
	customerOrders: Array<CustomerOrderView>;
	shopOrders: Array<ShopOrderView>;
}
